import api from "@/lib/api";

const strip = (p) => p.replace(/^\/(es|fr|ar|hmn)(?=\/)/, "");
const LANDING = strip(window.location.pathname);
let tracked = false;
let last = { key: "", at: 0 };

export const trackView = (payload) => {
  const key = `${window.location.pathname}|${payload.kind}|${payload.lang}`;
  if (key === last.key && Date.now() - last.at < 2000) return;
  last = { key, at: Date.now() };
  const internal = tracked || strip(window.location.pathname) !== LANDING;
  tracked = true;
  api.post("/places/view", { ...payload, referrer: internal ? "" : document.referrer, internal }).catch(() => {});
};
